import React from 'react';
import {
  Snackbar
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import { useLanguageSettings} from '../../Settings/useLanguageSettings';


const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '800px',
    marginBottom: '50px'
  },
}));

export default function SaveMessage(props) {

  const classes = useStyles();

  const { openSnackbar } = props;

  const [open, setOpen] = useState(false);
  const { templateLanguageContent, getTemplateLanguageContent } = useLanguageSettings();
  const [successContent, setSuccessContent] = useState(null);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    openSnackbar && setOpen(true)
  }, [openSnackbar]);

  useEffect(() => {
    setOpen(false)
  }, []);

  useEffect(() => {
    if (templateLanguageContent) {
      setSuccessContent(getTemplateLanguageContent("success"));
    }
  }, [templateLanguageContent]);

  return (
    <Snackbar
      className={classes.root}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}>
      <Alert onClose={handleClose} severity="success">
        {successContent?.saveSuccess || `Saved Successfully`}
        </Alert>
    </Snackbar>
  );
}